/**
 * Timeline editing modes that control how element operations handle conflicts
 */
export enum TimelineMode {
  /**
   * Default mode - Elements can only be moved if there's space
   * Operations will fail if they would cause elements to overlap
   */
  DEFAULT = 'DEFAULT',

  /**
   * Ripple mode - Moving elements will push other elements
   * If an element is moved to a position where another element exists,
   * that element and all subsequent elements will be pushed to make room
   */
  RIPPLE = 'RIPPLE',

  /**
   * Overlap mode - Elements can freely overlap
   * No collision detection is performed
   */
  OVERLAP = 'OVERLAP',
}
